import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-flex-column p-flex-md-row" }, null, -1)
const _hoisted_2 = { class: "p-d-flex p-flex-column p-flex-md-row p-jc-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  class: "p-p-2",
  href: "https://SwissFungi.wsl.ch/de/index.html",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-home" }),
  /*#__PURE__*/_createTextVNode(" Homepage SwissFungi")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  class: "p-p-2",
  href: "mailto:SwissFungi@wsl.ch",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-send" }),
  /*#__PURE__*/_createTextVNode(" SwissFungi@wsl.ch")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Divider, { layout: "vertical" }),
      _hoisted_4
    ])
  ], 64))
}